var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCurve = function SvgCurve(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.197,
    height: 36.188,
    viewBox: "0 0 36.197 36.188",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tomb",
    transform: "translate(0 -0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779",
    transform: "translate(6.15 0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    "data-name": "Group 1774",
    transform: "translate(0 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26165",
    "data-name": "Path 26165",
    d: "M110.872,30.288h-23.9V11.317A11.253,11.253,0,0,1,98.228.064h1.39a11.253,11.253,0,0,1,11.253,11.253Z",
    transform: "translate(-86.975 -0.064)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778",
    transform: "translate(6.541 10.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26167",
    "data-name": "Path 26167",
    d: "M189.229,148.806h-8.694a1.061,1.061,0,0,1,0-2.121h8.694a1.061,1.061,0,0,1,0,2.121Z",
    transform: "translate(-179.474 -146.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26168",
    "data-name": "Path 26168",
    d: "M260.3,146.685h-4.347v2.121H260.3a1.061,1.061,0,1,0,0-2.121Z",
    transform: "translate(-250.544 -146.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776",
    transform: "translate(0 4.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26169",
    "data-name": "Path 26169",
    d: "M189.229,208.806h-8.694a1.061,1.061,0,0,1,0-2.121h8.694a1.061,1.061,0,0,1,0,2.121Z",
    transform: "translate(-179.474 -206.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26170",
    "data-name": "Path 26170",
    d: "M260.3,206.685h-4.347v2.121H260.3a1.061,1.061,0,1,0,0-2.121Z",
    transform: "translate(-250.544 -206.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(0 8.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26171",
    "data-name": "Path 26171",
    d: "M189.229,268.806h-8.694a1.061,1.061,0,0,1,0-2.121h8.694a1.061,1.061,0,0,1,0,2.121Z",
    transform: "translate(-179.474 -266.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26172",
    "data-name": "Path 26172",
    d: "M260.3,266.685h-4.347v2.121H260.3a1.061,1.061,0,0,0,0-2.121Z",
    transform: "translate(-250.544 -266.685)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782",
    transform: "translate(0 27.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1780",
    "data-name": "Group 1780",
    transform: "translate(2.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26173",
    "data-name": "Path 26173",
    d: "M63.431,389.519H31.72v-3.431a1.061,1.061,0,0,1,1.061-1.061h29.59a1.061,1.061,0,0,1,1.061,1.061Z",
    transform: "translate(-31.72 -385.027)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1781",
    "data-name": "Group 1781",
    transform: "translate(0 4.492)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26175",
    "data-name": "Path 26175",
    d: "M36.2,453.03H0v-3.414a1.061,1.061,0,0,1,1.061-1.061H35.137a1.061,1.061,0,0,1,1.061,1.061Z",
    transform: "translate(0 -448.555)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurve, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/curve.8c366dae.svg";
export { ForwardRef as ReactComponent };